export const SMP_ID_PREFIX = 'SMP';

export const isSmpEmployeeId = (id?: string): boolean => !!id?.startsWith(SMP_ID_PREFIX);
